import { render, staticRenderFns } from "./watchBackPackDetails.vue?vue&type=template&id=0da54842&scoped=true&"
import script from "./watchBackPackDetails.vue?vue&type=script&lang=js&"
export * from "./watchBackPackDetails.vue?vue&type=script&lang=js&"
import style0 from "./watchBackPackDetails.vue?vue&type=style&index=0&id=0da54842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da54842",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0da54842')) {
      api.createRecord('0da54842', component.options)
    } else {
      api.reload('0da54842', component.options)
    }
    module.hot.accept("./watchBackPackDetails.vue?vue&type=template&id=0da54842&scoped=true&", function () {
      api.rerender('0da54842', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/components/watchBackPackDetails.vue"
export default component.exports